(function($){
    $(function(){
        var $newsSearch = $('.zn-news-filters'), 
            $doc = $(document),
            actClass = 'zn-active',
            appendCheckboxesToString = function(elements){
                var result = '';
                for (var i = 0; i < elements.length; i++){
                    if (elements[i].checked){
                        result += elements[i].value;

                        if (i !== elements.length){
                            result += ',';
                        }
                    }
                }
                return result;
            },
            selectBoxClose = function(i, toggle, panel){
                var container = i;
                $doc.on('click.lsOff', function(e){
                    if(!container.is(e.target) && container.has(e.target).length === 0){
                        container.removeClass(actClass).find(panel).slideUp(400);
                        container.find(toggle).attr('aria-expanded', 'false'); 
                        $doc.off('click.lsOff');
                    }
                });
                $doc.on('keydown.lsOff', function(e){
                    if (e.which === 27){
                        container.removeClass(actClass).find(panel).slideUp(400);
                        container.find(toggle).attr('aria-expanded', 'false'); 
                        $doc.off('keydown.lsOff');
                    }
                });
            },
            bindSelectBox = function(selectBox, toggle, panel){
                selectBox.find(toggle).on('click.ls', function(e){
                    e.preventDefault();
              
                    var $this = $(this).parent(selectBox),
                        $selectBoxStage = $this.find(panel);
              
                    if(!$this.hasClass(actClass)){
                        $(this).attr('aria-expanded', 'true');
                        $this.addClass(actClass);
                        $selectBoxStage.slideDown(400);
                        $doc.trigger('click');             
                        selectBoxClose($this, toggle, panel);
                    } else {
                        $(this).attr('aria-expanded', 'false');
                        $this.removeClass(actClass);
                        $selectBoxStage.slideUp(400);
                        $doc.off('click.lsOff');
                    }
                });
        
                selectBox.find(toggle).addAccess().attr('aria-expanded', 'false');
            };
      
        if ($newsSearch.length){
            bindSelectBox($('.zn-filter-toggle').parent('.zn-field-group'), '.zn-filter-toggle', '.zn-filter-panel');
      
            $('.zn-news-filters input[type="checkbox"]').on('change', function(){
                var  $this = $(this),
                    labelValue = $this.val(),
                    labelText = $this.next('label').text(),
                    $selectSpan = $('<span class="' + labelValue + ' zn-select-text">' + labelText + '</span>'),
                    $selectionBox = $this.closest('.zn-filter-panel').prev('.zn-filter-toggle').children('.zn-filter-selection');
      
                if ($this.is(':checked')){
                    $selectSpan.appendTo($selectionBox);
                } else if (labelValue){
                    $selectionBox.find('.' + labelValue).remove();
                }
            
                if ($selectionBox.is(':empty') && $selectionBox.is(':visible')){
                    $selectionBox.fadeOut('fast');
                } else if (!$selectionBox.is(':empty') && !$selectionBox.is(':visible')){
                    $selectionBox.fadeIn('fast');
                }
            });
      
            $('.zn-news-filters input[type="checkbox"]').trigger('change');
      
            $('.category-checkboxes label, .location-checkboxes label').addAccess();

            //Form submit
            $('#zn-news-filters-form').submit(function(e){
                e.preventDefault();

                var categories = document.getElementsByName('resource_topic'),
                    types = document.getElementsByName('resource_type'),
                    textSearch = $('#zn-news-search-text').val(),
                    catStr = appendCheckboxesToString(categories),
                    typeStr = appendCheckboxesToString(types);

        
                window.location.search = '?' + 
        (textSearch.length ? '&s=' + textSearch : '') +
        (catStr.length ? '&resource_topic=' + catStr : '') +
        (typeStr.length ? '&resource_type=' + typeStr : '');
            });
        }
    });

})($JQ);

